module.exports = __webpack_public_path__ + "static/media/20170806_01day_0028AT.8b2e690a.jpg";